<template>
  <div>
    <div class="d-flex align-center justify-center mb-5 mx-5">
      <v-tooltip
        top
        v-if="$moment(config.today).format('Y-M').toString() !== $moment(activeDate).format('Y-M').toString()"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            elevation="0"
            rounded
            class="mr-2"
            v-bind="attrs"
            v-on="on"
            @click="setToday"
            fab
            :disabled="$store.state.calendar.events.loading"
          >
            <Icon
              :width="18"
              :height="18"
              :color="'#000'"
              :icon="'chevron-left'"
            />
          </v-btn>
        </template>
        <span>
          {{$t('calendar.getBack')}}
        </span>
      </v-tooltip>
      <div class="px-1">
        <h4
          v-if="$refs.calendar"
          class="text--secondary text-capitalize font-weight-regular"
        >
          {{ $refs.calendar.title }}
        </h4>
      </div>
      <v-spacer></v-spacer>
      <div class="px-2">
        <v-btn
          rounded
          small
          @click="prev"
          elevation="0"
          :disabled="$store.state.calendar.events.loading"
          v-if="Number($moment(activeDate).format('YMM').toString()) > Number($moment(config.today).format('YMM').toString())"
        >
          <Icon
            :width="16"
            :height="16"
            :icon="'chevron-left'"
          />
          <Icon
            :width="12"
            :height="12"
            :icon="'calendar'"
          />
        </v-btn>
      </div>
      <div class="pl-2">
        <v-btn
          rounded
          small
          @click="next"
          elevation="0"
          :disabled="$store.state.calendar.events.loading"
        >
          <Icon
            :width="12"
            :height="12"
            :icon="'calendar'"
          />
          <Icon
            :width="16"
            :height="16"
            :icon="'chevron-right'"
          />
        </v-btn>
      </div>
    </div>
    <v-card
      loader-height="3"
      :loading="$store.state.calendar.events.loading"
      :disabled="$store.state.calendar.events.loading"
      elevation="0"
      rounded="0"
      class="px-2"
    >
      <div class="py-5">
        <v-calendar
          v-if="btnPrimaryConfig.data"
          ref="calendar"
          v-model="activeDate"
          :color="btnPrimaryConfig.data.btn"
          :style="`color: ${btnPrimaryConfig.data.text}`"
          :weekdays="config.weekday"
          :type="config.type"
          :events="$store.state.calendar.events.list"
          :event-overlap-mode="config.mode"
          :event-overlap-threshold="30"
          :locale="$store.state.locale"
          @click:date="viewDay"
          @click:more="viewDay"
        ></v-calendar>
      </div>
    </v-card>
    <Sheet
      :selectedDay="selectedDay"
      ref="sheet"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'

require('@/plugins/OcularMoment')
require('@/services/Calendar')

@Component({
  watch: {
    activeDate: function () {
      this.getEvents()
    },
    '$store.state.calendar.events.loading': function (loading) {
      if (!loading) {
        this.renderEvents()
      }
    }
  },
  components: {
    Sheet: () => import(/* webpackPrefetch: true */ '@/views/calendar/components/Sheet.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  computed: {
    btnPrimaryConfig () {
      return this.$organization.btnPrimaryConfig()
    }
  }
})
export default class Calendar extends Vue {
  data () {
    return {
      config: {
        today: new Date(),
        type: 'month',
        mode: 'column',
        weekday: [ 0, 1, 2, 3, 4, 5, 6 ],
        color: 'primary'
      },
      title: '',
      activeDate: new Date(),
      selectedDay: null,
    }
  }

  mounted () {
    this.setToday()
    this.ocGoogleAnalyticsInit()
  }

  setToday () {
    this.activeDate = this.config.today
  }

  viewDay ({ date }) {
    this.selectedDay = date
    this.$refs.sheet.show()

    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action: 'Seleccionó una fecha',
      detail: 'El cliente seleccionó una fecha',
      functionalityData: {
        selectedDay: this.selectedDay
      },
      actionType: 'SVAH',
      functionality: 4,
      historyInteractionType: 'OSIFDV'
    })
  }

  prev () {
    this.$refs.calendar.prev()
  }

  next () {
    this.$refs.calendar.next()
  }

  getEvents () {
    // Hay un bug aca
    if (typeof this.activeDate === 'string') {
      this.activeDate = new Date(this.activeDate)
    }

    this.$store.state.calendar.events.loading = true
    this.$store.state.calendar.events.list = []
    this.renderEvents()

    const params = {
      month: (`0${this.activeDate.getMonth() + 1}`).slice(-2),
      year: this.activeDate.getFullYear(),
      timeZone: this.$widget.getDevice().timeZone
    }

    if (this.$store.state.storage.category) {
      params.categoryId = this.$store.state.storage.category.id
    }

    this.$calendar.getAvailableDates(params)
  }

  renderEvents () {
    setTimeout(() => {
      const eventElements = document.querySelectorAll('.v-event')
      const activeEvents = document.querySelectorAll('.v-calendar-weekly__day button')

      for (let index = 0; index < activeEvents.length; index++) {
        const activeEvent = activeEvents[index]
        activeEvent.classList.remove('primary')
      }

      for (let index = 0; index < eventElements.length; index++) {
        const eventElement = eventElements[index]
        const buttonElement = eventElement.parentElement.querySelector('.v-calendar-weekly__day-label button')

        buttonElement.classList.remove('transparent')
        buttonElement.classList.add('primary')
      }
    }, 100)
  }

  ocGoogleAnalyticsInit () {
    OcGoogleAnalytics.getDataLayerConfig('init')
  }
}
</script>

<style>
.v-calendar {
  border: 0 !important
}

.v-calendar .v-event, .v-event-more {
  display: none !important;
}

.v-calendar .v-btn__content {
  font-size: 12px;
}

.v-calendar .v-calendar-weekly__day {
  border: 0 !important;
}

.v-calendar .v-calendar-weekly__day button {
  margin: 8px 0;
}

.v-calendar .v-calendar-weekly__day.v-past .v-calendar-weekly__day-label button:not(.primary) .v-btn__content {
  opacity: .2 !important;
  text-decoration: none;
}

.v-calendar .v-calendar-weekly__day .v-calendar-weekly__day-label button:not(.primary) .v-btn__content {
  opacity: .5 !important;
  text-decoration: line-through;
}

.v-calendar .v-calendar-weekly__head-weekday {
  border: 0 !important;
}
</style>
